<template>
  <div>
    <div class="formula-flex">
      <div class="formula-item" v-for="(item,index) in formulaList" :key="index">
        <el-button class="formula-button" size="small" v-html="item.value" @click="formulaShow=index+1"></el-button>
      </div>
    </div>
    <div class="formula-center" style="position:relative;width:60px" v-if="formulaShow==1">
      <div v-html="formulaList[0].value"></div>
    </div>
    <div class="formula-center" style="position:relative;width:60px" v-if="formulaShow==2">
      <div class="formula-radical" v-html="radical"></div>
      <el-input v-model="input1" class="formula-radical-bottom"></el-input>
    </div>
    <div class="formula-center" style="position:relative;width:60px" v-if="formulaShow==3">
      <el-input v-model="input2" class="formula-radical-top"></el-input>
      <div class="formula-radical" v-html="radical"></div>
      <el-input v-model="input3" class="formula-radical-bottom"></el-input>
    </div>
    <div class="formula-center" v-if="formulaShow==4">
      <el-input v-model="input4" class="formula-mark-top"></el-input>
      <div class="formula-mark-line"></div>
      <el-input v-model="input5" class="formula-mark-bottom"></el-input>
    </div>
    <div style="height:20px">
    <div style="float:right">
      <el-button @click="goBack()">取 消</el-button>
      <el-button type="primary" @click="submit()">确 定</el-button>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input1: null,
      input2: null,
      input3: null,
      input4: null,
      input5: null,
      formulaShow: null,
      radical: '<svg width="400em" height="1.08em" viewBox="0 0 400000 1080" preserveAspectRatio="xMinYMin slice"><path d="M95,702c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429c69,-144,104.5,-217.7,106.5,-221l0 -0c5.3,-9.3,12,-14,20,-14H400000v40H845.2724s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47zM834 80h400000v40h-400000z"></path></svg>',
      formulaList: [
        { value: "≠" },
        // {
        //   value:
        //     '<span class="ql-formula" data-value="left(x^{smash{2}}\right)">&#65279;<span contenteditable="false"><span class="katex"><span class="katex-mathml"><math xmlns="http://www.w3.org/1998/Math/MathML"><semantics><mrow><mo fence="true">(</mo><msup><mi>x</mi><mpadded height="0px" depth="0px"><mn>2</mn></mpadded></msup><mo fence="true">)</mo></mrow><annotation encoding="application/x-tex">left(x^{smash{2}}\right)</annotation></semantics></math></span><span class="katex-html" aria-hidden="true"><span class="base"><span class="strut" style="height: 1em; vertical-align: -0.25em;"></span><span class="minner"><span class="mopen delimcenter" style="top: 0em;">(</span><span class="mord"><span class="mord mathdefault">x</span><span class="msupsub"><span class="vlist-t"><span class="vlist-r"><span class="vlist" style="height: 0.363em;"><span class="" style="top: -3.063em; margin-right: 0.05em;"><span class="pstrut" style="height: 2.7em;"></span><span class="sizing reset-size6 size3 mtight"><span class="mord mtight"><span class="mord mtight"><span class="vlist-t"><span class="vlist-r"><span class="vlist" style="height: 0em;"><span class="" style="top: -2.7em;"><span class="pstrut" style="height: 2.7em;"></span><span class=""><span class="mord mtight"><span class="mord mtight">2</span></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span><span class="mclose delimcenter" style="top: 0em;">)</span></span></span></span></span></span>&#65279;</span>',
        // },
        {
          value:
            '<span class="katex"><span class="katex-mathml"><math xmlns="http://www.w3.org/1998/Math/MathML"><semantics><mrow><msqrt><mi>x</mi></msqrt></mrow><annotation encoding="application/x-tex">sqrt{x}</annotation></semantics></math></span><span aria-hidden="true" class="katex-html"><span class="base"><span class="strut" style="height: 1.04em; vertical-align: -0.23972em;"></span><span class="mord sqrt"><span class="vlist-t vlist-t2"><span class="vlist-r"><span class="vlist" style="height: 0.80028em;"><span class="svg-align" style="top: -3em;"><span class="pstrut" style="height: 3em;"></span><span class="mord" style="padding-left: 0.833em;"><span class="mord mathdefault">x</span></span></span><span style="top: -2.76028em;"><span class="pstrut" style="height: 3em;"></span><span class="hide-tail" style="min-width: 0.853em; height: 1.08em;"><svg width="400em" height="1.08em" viewBox="0 0 400000 1080" preserveAspectRatio="xMinYMin slice"><path d="M95,702c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429c69,-144,104.5,-217.7,106.5,-221l0 -0c5.3,-9.3,12,-14,20,-14H400000v40H845.2724s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47zM834 80h400000v40h-400000z"></path></svg></span></span></span><span class="vlist-s">&#8203;</span></span><span class="vlist-r"><span class="vlist" style="height: 0.23972em;"><span></span></span></span></span></span></span></span></span>',
        },
        {
          value:
            '<span class="katex"><span class="katex-mathml"><math xmlns="http://www.w3.org/1998/Math/MathML"><semantics><mrow><mroot><mi>x</mi><mi>y</mi></mroot></mrow><annotation encoding="application/x-tex">\sqrt[y]{x}</annotation></semantics></math></span><span class="katex-html" aria-hidden="true"><span class="base"><span class="strut" style="height: 1.04em; vertical-align: -0.23972em;"></span><span class="mord sqrt"><span class="root"><span class="vlist-t"><span class="vlist-r"><span class="vlist" style="height: 0.551616em;"><span class="" style="top: -2.83634em;"><span class="pstrut" style="height: 2.5em;"></span><span class="sizing reset-size6 size1 mtight"><span class="mord mtight"><span class="mord mathdefault mtight" style="margin-right: 0.03588em;">y</span></span></span></span></span></span></span></span><span class="vlist-t vlist-t2"><span class="vlist-r"><span class="vlist" style="height: 0.80028em;"><span class="svg-align" style="top: -3em;"><span class="pstrut" style="height: 3em;"></span><span class="mord" style="padding-left: 0.833em;"><span class="mord mathdefault">x</span></span></span><span class="" style="top: -2.76028em;"><span class="pstrut" style="height: 3em;"></span><span class="hide-tail" style="min-width: 0.853em; height: 1.08em;"><svg width="400em" height="1.08em" viewBox="0 0 400000 1080" preserveAspectRatio="xMinYMin slice"><path d="M95,702c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429c69,-144,104.5,-217.7,106.5,-221l0 -0c5.3,-9.3,12,-14,20,-14H400000v40H845.2724s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47zM834 80h400000v40h-400000z"></path></svg></span></span></span><span class="vlist-s">&#8203;</span></span><span class="vlist-r"><span class="vlist" style="height: 0.23972em;"><span class=""></span></span></span></span></span></span></span></span>',
        },
        {
          value:
            '<span class="katex"><span class="katex-mathml"><math xmlns="http://www.w3.org/1998/Math/MathML"><semantics><mrow><mstyle displaystyle="true" scriptlevel="0"><mfrac><mi>a</mi><mi>b</mi></mfrac></mstyle></mrow><annotation encoding="application/x-tex">dfrac{a}{b}</annotation></semantics></math></span><span class="katex-html" aria-hidden="true"><span class="base"><span class="strut" style="height: 1.79356em; vertical-align: -0.686em;"></span><span class="mord"><span class="mopen nulldelimiter"></span><span class="mfrac"><span class="vlist-t vlist-t2"><span class="vlist-r"><span class="vlist" style="height: 1.10756em;"><span class="" style="top: -2.314em;"><span class="pstrut" style="height: 3em;"></span><span class="mord"><span class="mord mathdefault">b</span></span></span><span class="" style="top: -3.23em;"><span class="pstrut" style="height: 3em;"></span><span class="frac-line" style="border-bottom-width: 0.04em;"></span></span><span class="" style="top: -3.677em;"><span class="pstrut" style="height: 3em;"></span><span class="mord"><span class="mord mathdefault">a</span></span></span></span><span class="vlist-s">&#8203;</span></span><span class="vlist-r"><span class="vlist" style="height: 0.686em;"><span class=""></span></span></span></span></span><span class="mclose nulldelimiter"></span></span></span></span></span>',
        },
      ],
    };
  },
  props: {
    refff: "",
  },
  
  mounted: function() {
  },
  methods:{
    goBack(){
      this.$emit("dialogChange",false)
    },
    submit(){
      if(this.formulaShow === 1){
        let val = '{=}\\mathllap{/\\,}'
        let obj = {
          refff: this.refff,
          val: val
        }
        this.$emit("formulaChange",obj)
        this.input1 = null;
        this.input2 = null;
        this.input3 = null;
        this.input4 = null;
        this.input5 = null;
      }
      if(this.formulaShow === 2){
        if(this.input1==null){
          this.$message.error("请输入内容！")
          return;
        }
        let val = '\\sqrt{' + this.input1 + '}'
        let obj = {
          refff: this.refff,
          val: val
        }
        console.log("obj",obj)
        this.$emit("formulaChange",obj)
        this.input1 = null;
        this.input2 = null;
        this.input3 = null;
        this.input4 = null;
        this.input5 = null;
      }
      if(this.formulaShow === 3){
        if(this.input2==null||this.input3==null){
          this.$message.error("请输入内容！")
          return;
        }
        let val = '\\sqrt[' + this.input2 + ']{' + this.input3 + '}'
        let obj = {
          refff: this.refff,
          val: val
        }
        this.$emit("formulaChange",obj)
        this.input1 = null;
        this.input2 = null;
        this.input3 = null;
        this.input4 = null;
        this.input5 = null;
      }
      if(this.formulaShow === 4){
        if(this.input4==null||this.input5==null){
          this.$message.error("请输入内容！")
          return;
        }
        let val = '\\dfrac{' + this.input4 + '}{' + this.input5 + '}'
        let obj = {
          refff: this.refff,
          val: val
        }
        this.$emit("formulaChange",obj)
        this.input1 = null;
        this.input2 = null;
        this.input3 = null;
        this.input4 = null;
        this.input5 = null;
      }

    },
  }
};
</script>
<style lang="less">
.formula-flex {
  display: flex;
  flex-wrap: wrap;
}
.formula-item {
  margin-right: 20px;
  margin-bottom: 20px;
}
.formula-button {
  height: 36.8px;
}
.formula-center{
  height: 80px;
  margin: auto;
  width: 42px;
}
.formula-mark-top{
  width: 40px;
  margin-bottom: 5px;
}
.formula-mark-bottom{
  width: 40px;
  margin-top: 5px;
}
.formula-mark-line{
  border-top: 1px solid #000;
}
.formula-radical{
  width: 40px;
  overflow: hidden;
  margin-left: 20px;
}
.formula-radical-top{
  .el-input__inner{
    height: 20px!important;
    width: 20px!important;
    padding: 0px!important;
  }
  position: absolute!important;
}
.formula-radical-bottom{
  .el-input__inner{
    width: 30px;
    padding: 0px!important;
  }
  top: 20px;
  margin-left: 30px;
  position: absolute!important;
}
</style>


// WEBPACK FOOTER //
// src/components/question/formula.vue